import { useEffect, useRef, useState } from 'react';

const modalTypeToHash = {
  privacy: '#privacy',
  terms: '#terms',
  cookie: '#cookies',
};

const hashToModalType = (hash) => {
  switch (hash) {
    case '#privacy': return 'privacy';
    case '#terms': return 'terms';
    case '#cookies': return 'cookie';
    default: return null;
  }
};

const useLegalModal = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState('terms');
  const ignoreHashChangeRef = useRef(false);

  const openModal = (type) => {
    setModalType(type);
    setModalOpen(true);
    const hash = modalTypeToHash[type];

    if (hash && window.location.hash !== hash) {
      ignoreHashChangeRef.current = true;
      window.location.hash = hash;
    }
  };

  const closeModal = () => {
    setModalOpen(false);

    if (window.location.hash !== '') {
      ignoreHashChangeRef.current = true;
      window.location.hash = '';
    }
  };

  const openCookieSettings = () => {
    if (window.CookieConsent && typeof window.CookieConsent.showSettings === 'function') {
      window.CookieConsent.showSettings();
      return;
    }

    openModal('cookie');
  };

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        closeModal();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, []);

  useEffect(() => {
    const handleHashChange = () => {
      if (ignoreHashChangeRef.current) {
        ignoreHashChangeRef.current = false;
        return;
      }

      const nextModalType = hashToModalType(window.location.hash);
      if (nextModalType) {
        setModalType(nextModalType);
        setModalOpen(true);
      } else {
        setModalOpen(false);
      }
    };

    handleHashChange();
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  return {
    modalOpen,
    modalType,
    openModal,
    closeModal,
    openCookieSettings,
  };
};

export default useLegalModal;
